import { Box, Grid, Link, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { useLocalization } from "../hooks/useLocalization";
import { Rw1LogoColored } from "../icons/RW1LogoColored";

const companyEmailContact = "info@realworld-one.com";
const companyPhones = {
  china: "+8613926234932",
  germany: "+497613809980",
  usa: "+19107425192",
};

export const Footer: React.FC = () => {
  const { t } = useLocalization();
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: "156px",
        padding: { xs: 4, md: "8px 56px" },
        width: "100%",
      }}
    >
      <Grid container spacing={4}>
        {/* Left Column */}
        <Grid item md={8} xs={12}>
          <Stack spacing={2}>
            {/* Logo */}
            <Rw1LogoColored
              style={{ height: "auto", width: "9.5rem", marginLeft: "-8px" }}
            />

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 4, sm: 8 }}
            >
              {/* Call Us */}
              <Stack spacing={1}>
                <Typography
                  fontWeight="bold"
                  sx={{
                    textTransform: "uppercase",
                    color: theme.colors.text[0],
                  }}
                  variant="subtitle2"
                >
                  {t("components.footer.callUs")}
                </Typography>
                <Stack spacing={0}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body2">
                      {t("components.footer.germany")}:
                    </Typography>
                    <Link
                      color="text.primary"
                      fontWeight="medium"
                      href={`tel:${companyPhones.germany}`}
                      underline="always"
                    >
                      {companyPhones.germany}
                    </Link>
                  </Stack>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body2">
                      {t("components.footer.usa")}:
                    </Typography>
                    <Link
                      color="text.primary"
                      fontWeight="medium"
                      href={`tel:${companyPhones.usa}`}
                      underline="always"
                    >
                      {companyPhones.usa}
                    </Link>
                  </Stack>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body2">
                      {t("components.footer.china")}:
                    </Typography>
                    <Link
                      color="text.primary"
                      fontWeight="medium"
                      href={`tel:${companyPhones.china}`}
                      underline="always"
                    >
                      {companyPhones.china}
                    </Link>
                  </Stack>
                </Stack>
              </Stack>

              {/* Email Us */}
              <Stack spacing={1}>
                <Typography
                  fontWeight="bold"
                  sx={{
                    textTransform: "uppercase",
                    color: theme.colors.text[0],
                  }}
                  variant="subtitle2"
                >
                  {t("components.footer.emailUs")}
                </Typography>
                <Link
                  color="text.primary"
                  fontWeight="medium"
                  href={`mailto:${companyEmailContact}`}
                  underline="always"
                >
                  {companyEmailContact}
                </Link>
              </Stack>
            </Stack>
          </Stack>
        </Grid>

        {/* Right Column */}
        <Grid item md={4} xs={12}>
          <Stack
            alignItems={{ xs: "flex-start", md: "flex-end" }}
            height="100%"
            justifyContent="flex-end"
            spacing={1}
          >
            <Link
              color={theme.colors.text[0]}
              fontWeight="bold"
              href="https://realworld-one.com/privacy-notice"
              sx={{ fontSize: "0.875rem" }}
              underline="always"
            >
              {t("components.footer.privacyNotice")}
            </Link>
            <Link
              color={theme.colors.text[0]}
              fontWeight="bold"
              href="https://realworld-one.com/imprint"
              sx={{ fontSize: "0.875rem" }}
              underline="always"
            >
              {t("components.footer.imprint")}
            </Link>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};
